module.exports = __webpack_public_path__ + "760b139c78c9a7fa0feb6b09a931999e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WTA-Zone_Headers.png
// module id = 516
// module chunks = 0